import { AnimatePresence, motion } from 'framer-motion';
import { MdDeleteOutline } from 'react-icons/md';

import { ImageData, ImagesData, variants } from '@/slw/entities/chat';
import { ImageLoader } from '@/slw/widgets/common/image-loader.ui';

type ImageUploadProps = {
  imagesPreview: ImagesData;
  openModal: (data: ImageData) => void;
  removeImage: (targetId: number) => void;
};

export function ImageUpload({ imagesPreview, openModal, removeImage }: ImageUploadProps) {
  return (
    <motion.div
      className='flex gap-2 overflow-x-auto overflow-y-hidden px-2 max-h-[240px] w-full 
      scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent'
      style={{ scrollbarWidth: 'thin', msOverflowStyle: 'none' }}
      variants={variants}
      initial='initial'
      animate='animate'
      exit='exit'
    >
      <AnimatePresence initial={false}>
        {imagesPreview.map(({ id, src, alt }) => (
          <motion.div
            className='relative flex h-20 w-20 flex-col border items-center gap-1 rounded-sm flex-shrink-0 group'
            layout
            initial={{ top: 100, opacity: 0 }}
            animate={{ top: 0, opacity: 1 }}
            exit={{ top: 100, opacity: 0, transition: { duration: 0.2 } }}
            key={id}
          >
            <button
              className='absolute hidden group-hover:block hover:text-destructive text-white transition duration-100 
              group-focus:visible top-1 right-1 z-10
               cursor-pointer'
              aria-label='Remove image'
              onClick={() => removeImage(id)}
              type='button'
            >
              <MdDeleteOutline size={16} />
            </button>
            <ImageLoader
              src={src}
              alt={alt}
              divStyle='flex h-full justify-center items-center w-full rounded-sm'
              imageStyle='w-full h-full rounded-sm'
              objectFit='cover'
              onClick={() => openModal({ src, alt })}
              noPlaceholder
            />
            {/* <p className='trim-alt mx-2 pb-0.5 text-xs text-primary/80'>{alt}</p> */}
          </motion.div>
        ))}
      </AnimatePresence>
    </motion.div>
  );
}
